<template>
    <div class="task-list">
        <div class="task-breadcrumb">
            <span>工作台</span>
            <i class="el-icon-arrow-right"></i>
            <span class="to">我的任务</span>
        </div>

        <div class="task-box">
            <div class="box-tabs">
                <div
                    :class="['tab-item', { active: currentTab === tab.value }]"
                    v-for="tab in tabList"
                    :key="tab.value"
                    @click="handleChangeTab(tab)"
                >
                    {{ tab.label }}
                </div>
            </div>

            <div class="box-filter">
                <div class="filter-item flex-center" v-for="item in filterList" :key="item.key">
                    <div class="filter-label">{{ item.label }}</div>

                    <template v-if="item.type === 'input'">
                        <el-input
                            v-model="filter[item.key]"
                            v-bind="item.attr ?? {}"
                            style="width: 240px"
                            @change="getList"
                            clearable
                        ></el-input>
                    </template>

                    <template v-if="item.type === 'select'">
                        <el-select v-model="filter[item.key]" style="width: 240px" @change="getList">
                            <el-option
                                v-for="item in item.options || []"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </template>
                </div>
            </div>

            <div class="box-table">
                <el-table :data="taskList" style="width: 100%" :header-cell-style="headerStyle">
                    <el-table-column label="需求名称">
                        <template slot-scope="scope">
                            <i :class="['task-mode', `task-mode-${scope.row.task_info?.task_mode}`]">{{ scope.row.task_info?.task_mode === 1 ? "招募" : "竞单" }}</i>
                            {{ scope.row.task_info?.task_name }}
                        </template>
                    </el-table-column>

                    <el-table-column label="需求状态">
                        <template slot-scope="scope">
                            <span style="color: #eda147" v-if="scope.row.task_info?.task_status === 1">报名中</span>
                            <span style="color: #594fed" v-if="scope.row.task_info?.task_status === 2">进行中</span>
                            <span v-if="scope.row.task_info?.task_status === 3">圆满完成</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="需求情况">
                        <template slot-scope="scope">
                            <span :class="[`todo-${scope.row.task_info?.task_status}`]">
                                {{ todoMap[scope.row.todo_key] || "" }}
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column label="需求预算">
                        <template slot-scope="scope"> {{ scope.row.task_info?.task_budget }}金币 </template>
                    </el-table-column>

                    <el-table-column label="截止时间">
                        <template slot-scope="scope">
                            <span :class="[`time-${exipreTime(scope.row).type}`]">
                                {{ exipreTime(scope.row).label }}
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" width="100" :align="'right'">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleToDetail(scope.row)">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="box-pagination flex-center">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="pageParams.page"
                    :page-size="pageParams.page_size"
                    layout="prev, pager, next, jumper"
                    :total="pageParams.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import taskApi from "../../../apis/task";
import { getTimeLabel } from "../../company/new-task/util";

export default {
    data() {
        return {
            currentTab: 1,
            tabList: [
                { label: "我的待办", value: 1 },
                { label: "我参与的", value: 2 },
            ],
            pageParams: {
                page: 1,
                page_size: 10,
                total: 0,
            },
            filter: {
                filter_name: "",
                filter_status: 0,
                filter_mode: 0,
            },
            filterList: [
                {
                    label: "需求名称：",
                    type: "input",
                    key: "filter_name",
                    attr: {
                        placeholder: "请输入需求名称",
                    },
                },

                {
                    label: "需求状态：",
                    type: "select",
                    key: "filter_status",
                    attr: {
                        placeholder: "选择需求状态",
                    },
                    options: [
                        { label: "全部", value: 0 },
                        { label: "报名中", value: 1 },
                        { label: "进行中", value: 2 },
                        { label: "圆满完成", value: 3 },
                    ],
                },

                {
                    label: "解决方式：",
                    type: "select",
                    key: "filter_mode",
                    attr: {
                        placeholder: "请选择解决方式",
                    },
                    options: [
                        { label: "全部", value: 0 },
                        { label: "招募", value: 1 },
                        { label: "竞单", value: 2 },
                    ],
                },
            ],

            headerStyle: {
                background: "#F2F2F4",
                height: "37px",
                "font-size": "14px",
                color: "rgba(37,38,50,0.6)",
                padding: "0px",
            },

            taskList: [],

            todoMap: {
                0: "未报名", //学生取消报名后
                1: "待重新报名", //被设置为备选后
                2: "待签订合同", //需求方发起合同后
                3: "待交付成果", //接受合同后
                4: "待评价", //教师/企业验收通过
                5: "待重新交付成果", //成果被打回后
                6: "需求方甄选", //提交了报名
                7: "报名已淘汰", //被需求方淘汰
                8: "待发起合同", //需求方选中后
                9: "交付成果待审核", //交付成果后
                10: "已评价", //学生完成评价后
                11: "需求被下架", //已完成全部流程后 任务被删除
                12: "接单方工作", //学生确认合同后
                13: "验收交付成果", //学生提交成果后
                14: "酬劳结算", //验收通过后
                15: "中标公示", //竞单状态下选中学生
            },
        };
    },

    computed: {
        filterParams() {
            const params = {};

            if (this.filter.filter_name) params.filter_name = this.filter.filter_name;
            if (this.filter.filter_status !== 0) params.filter_status = this.filter.filter_status;
            if (this.filter.filter_mode !== 0) params.filter_mode = this.filter.filter_mode;

            return params;
        },
    },

    created() {
        this.getList();
    },

    methods: {
        handleChangeTab(tab) {
            if (tab.value !== this.currentTab) {
                this.pageParams.page = 1;
                this.currentTab = tab.value;

                this.getList();
            }
        },

        // 列表数据
        getList() {
            const params = {
                page: this.pageParams.page,
                page_size: this.pageParams.page_size,
                filter_todos: this.currentTab === 1 ? 1 : 0,
                ...this.filterParams,
            };

            this.$httpStudent.axiosGetBy(taskApi.studentTodo, params, (res) => {
                if (res.code === 200) {
                    this.taskList = res.data?.data ?? [];
                    this.pageParams.total = res.data?.total ?? 0;
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        // 分页
        handleCurrentChange(val) {
            this.pageParams.page = val;
            this.getList();
        },

        // 需求详情页
        handleToDetail(todo) {
            if (todo?.todo_key === 11) {
                this.$message.warning("需求已被下架，无法查看");
                return;
            }

            const url = this.$router.resolve({
                path: "/student/newTask/detail",
                query: { id: todo.task_id },
            }).href;

            window.open(url, "_blank");
        },

        // 截止日期数据
        exipreTime(todo) {
            const time = [0, 1]?.includes(todo.todo_key) ? todo.task_info?.task_start_time : todo.task_info?.task_end_time;

            const isExipre = Date.now() > new Date(time).getTime();

            return {
                type: isExipre ? "danger" : "normal",
                label: getTimeLabel(time),
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.task-list {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 100px);
    font-family: PingFang SC, PingFang SC;
    gap: 16px;

    .task-breadcrumb {
        span {
            font-weight: 400;
            font-size: 14px;
            color: #666666;

            &.to {
                color: #37383b;
            }
        }
    }

    .task-box {
        flex: 1;
        display: flex;
        flex-direction: column;

        .box-tabs {
            display: flex;
            height: 52px;

            .tab-item {
                min-width: 104px;
                display: flex;
                justify-content: center;
                align-items: center;
                // padding-inline: 20px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                color: #37383b;
                cursor: pointer;

                &.active {
                    color: #685df5;
                    background-color: #ffffff;
                    border-radius: 4px 4px 0px 0px;
                }
            }
        }

        .box-filter,
        .box-table,
        .box-pagination {
            background-color: #fff;
            box-sizing: border-box;
        }

        .box-filter {
            display: flex;
            align-items: center;
            gap: 32px;
            padding: 32px 40px 24px;

            ::v-deep .el-input__inner {
                height: 32px;
            }

            ::v-deep .el-input__icon {
                line-height: 32px;
            }
        }

        .box-table {
            flex: 1;
            // border: 1px solid black;
            padding-inline: 40px;

            .task-mode {
                width: 36px;
                height: 21px;
                border-radius: 2px;
                font-weight: 600;
                font-size: 12px;
                font-style: normal;
                text-align: center;
                margin-right: 4px;
                padding-inline: 2px;

                &-1 {
                    background: #f6ffed;
                    border: 1px solid #01a04b;
                    color: #6bc45c;
                }

                &-2 {
                    background: #fff4dd;
                    border: 1px solid #e49906;
                    color: #e49906;
                }
            }

            .todo-1 {
                color: #eda147;
            }

            .todo-2 {
                color: #594fed;
            }

            .time-danger {
                color: #ff0000;
            }
        }

        .box-pagination {
            height: 60px;
            border-top: 1px solid #ebeef5;
        }
    }
}
</style>
